import TabPageHeading from '../Layout/TabPageHeading';
import React from 'react';
import { CalendarCheck, Users } from 'lucide-react';
import { PLANNER_VIEWS, PlannerView } from '@radevents/shared';

export default function EventPlannerView({ view, onView, richtung, loading, error, empty, onRetry, cards, past, friends, leer }: {
  view: PlannerView; onView: (view: PlannerView) => void; richtung?: 'links' | 'rechts' | null; loading: boolean; error?: string; empty: boolean;
  onRetry: () => void; cards: React.ReactNode; past?: React.ReactNode; friends?: React.ReactNode;
  /** Eigener Leerzustand statt des Standardtexts; `null` heißt: keiner. */
  leer?: React.ReactNode;
}) {
  const current = PLANNER_VIEWS.find(v => v.id === view)!;
  return <section className="event-planner">
    <TabPageHeading unsichtbar>Meine Events</TabPageHeading>
    <div className="planner-tabs" role="group" aria-label="Eventansicht">
      {PLANNER_VIEWS.map((tab, i) => { const Icon = [CalendarCheck, Users][i]; return <button type="button" key={tab.id} aria-pressed={view === tab.id} onClick={() => onView(tab.id)}><Icon size={18} aria-hidden />{tab.label}</button>; })}
    </div>
    {/* Neu eingehängt je Ansicht, damit sie aus der Wechselrichtung hereingleitet. */}
    <div key={view} className={`planner-ansicht${richtung ? ` planner-ansicht--${richtung}` : ''}`}>
      {view === 'friends' && friends}
      {loading ? <div className="planner-month-events" role="status" aria-label="Events werden geladen">{[0, 1, 2].map(i => <div key={i} className="org-zeile-platzhalter" />)}</div> : error ? <div role="alert" className="planner-empty"><p>{error}</p><button onClick={onRetry}>Erneut versuchen</button></div> : <>
        {empty ? (leer !== undefined ? leer : <div className="planner-empty"><h2>{current.empty}</h2><p>{current.hint}</p></div>) : <div className="planner-agenda">{cards}</div>}
        {past}
      </>}
    </div>
  </section>;
}
